

export const DEVICES = [
    {
        label:'Full-screen',
        width: '100%',
        height: '100vh',
        background: '',
        value:'Full-screen'
    },
    {
        label:'Custom',
        width: '90%',
        height: '90vh',
        background: '',
        value:'Custom'
    },
    {
        label: 'Mobile',
        width: 405,
        height: 753,
        background: '',
        value: 'Mobile'
    }
];

export interface DevicesListProps {
    label: string;
    width: number | string;
    height: number | string;
    value: string;
}

export const EVENTS:any = {
    'ads': 'Ad start',
    // Environment events deprecated
    'ivi': 'Impression viewed',
    'irv': 'Impression really viewed',
    'ire': 'Impression ready',
    'pvi': 'Placement viewed',
    'pre': 'Placement ready',
    'cev': 'Custom Event',
    'clk': 'Click',
    'exp': 'Expansion',
    'rsz': 'Resize',
    'clo': 'Close',
    'ecl': 'Element clicked',
    'iim': 'Interacted impression',
    'scc': 'Scene change',
    'vst': 'Video started',
    'v25': 'Video first quartile (25%)',
    'v50': 'Video midpoints (50%)',
    'v75': 'Video third quartile (75%)',
    'vco': 'Video completed',
    'vre': 'Video replay',
    'vpa': 'Video pause',
    'vrs': 'Video resumed',
    'vse': 'Video seek',
    'vum': 'Video unmuted',
    'vmu': 'Video muted',
    'ssl': 'Slide',
    'sco': 'Slider completed',
    'tss': '360 swiped',
    'tsc': '360 completed',
    'ctc': 'Click to call',
    'cts': 'Click to SMS',
    'era': 'Eraser action',
    'erc': 'Eraser completed',
    'sbm': 'Form submitted',
    'apo': 'App opened',
    'min': 'Map interacted',
    'shk': 'Shake',
    'atc': 'Add to calendar',
    'ids': 'Image Diff slide',
    'tfc': 'Twitter Feed click',
    'tfs': 'Twitter Feed scroll',
    'ffc': 'Facebook Feed click',
    'ffs': 'Facebook Feed scroll',
    'ifc': 'Instagram Feed click',
    'ifs': 'Instagram Feed scroll',
    'pdl': 'Product Feed Downloaded',
    'sim': 'Store Impression',
    'sck': 'Store Click',
    'sqp': 'Video sequence play/pause',
    'sqr': 'Video sequence request',
    'sqc': 'Video sequence completed',
    'swi': 'Scene swiped',
    'drs': 'Drag interaction',
    'cwi': 'Auto close --no interaction',
    'cai': 'Auto close --with interaction',
    'pck': 'Product Click',
    'pim': 'Product Impression',
    'puu': 'Photo selected',
    'pum': 'Photo manipulated',
    'pup': 'Photo uploaded',
    '05s': 'Video 5 seconds mark',
    '15s': 'Video 15 seconds mark',
    'ch_opn': 'Chatbot Open',
    'ch_clo': 'Chatbot Close',
    'ch_sbm': 'Chatbot Submit',
    'ch_rsp': 'Chatbot Response',
    'aur': 'Auto play restricted',
};

export const ZOOM = {
    step: 0.05,
    min: 0.5,
    max: 2
}

export const TOP_PLACEMENT_FORMATS = [146, 46, 21];

export const ALERTS = {
    audio: {
        fail: 'There was an error trying to create dynamic ad. Please try again later.',
        wait: 'Please wait, we are creating dynamic version of the creative'
    },
    dooh: {
        fail: 'No DOOH images were created, try later or change parameters.'
    },
}

export const VAST_API_URL:any = {
    d: '/vast/demo/?state=',
    p: '/vast/preview/?'
}



